<template>
  <v-dialog v-model="open" :max-width="width || '400px'" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" :small="small" :rounded="rounded" :outlined="outlined" :text="text"
        :disabled="disabled" :class="actionClass" :color="actionColor">
        {{ actionText }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>

      <v-card-text>
        {{ description }}

        <slot></slot>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="cancel">
          Cancelar
        </v-btn>
        <v-btn :loading="loading" color="primary" text @click="callAction">
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    width: String,
    small: Boolean,
    rounded: Boolean,
    text: Boolean,
    outlined: Boolean,
    disabled: Boolean,
    actionText: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
    },
    action: {
      type: Function,
      required: true,
    },
    actionColor: {
      type: String,
      default: 'primary',
    },
    actionClass: String,
    onError: Function,
    onSuccess: Function,
  },
  methods: {
    cancel: function () {
      this.open = false
    },
    callAction: async function () {
      this.loading = true
      await this.action(this.formData)
        .then((res) => {
          if (this.onSuccess) this.onSuccess(res)
        }).catch((res) => {
          if (this.onError) this.onError(res)
        })
      this.open = false
      this.loading = false
    },
  },
  data: () => ({
    open: false,
    loading: false,
  }),
}
</script>

<style scoped></style>